module.exports = __webpack_public_path__ + "img/rope_ThimbleLock_4.01b5a6b8.png";